import axios from "@/axios";
import { ConfigurationsOutput, ConfigurationsOutputSchema } from "@/Schemas/Configurations/ConfigurationsOutput";
import { parseSchema } from "@/Utils/zodParser";

export const getConfigurations = async (): Promise<ConfigurationsOutput> => {
    const response = await axios.get("/api/configurations");
    return parseSchema(ConfigurationsOutputSchema, response.data);
}